const detectLanguage = (query) => {
  const tamilPattern = /[\u0B80-\u0BFF]+/;
  const sinhalaPattern = /[\u0D80-\u0DFF]+/;
  const englishPattern = /[A-Za-z]+/;

  if (tamilPattern.test(query)) return "tamil";
  if (sinhalaPattern.test(query)) return "sinhala";
  if (englishPattern.test(query)) return "english";
  return "unknown";
};

export default detectLanguage;
